module.exports = __webpack_public_path__ + "img/palette.41d89f5b.svg";